import routerOptions0 from "/app/seame-web-b2b/node_modules/.pnpm/nuxt@3.20.2_@parcel+watcher@2.5.4_@types+node@25.6.0_@vue+compiler-sfc@3.5.27_cac@6.7.14_comm_mtinmsannowavapelhrobmcmsu/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/app/seame-web-b2b/apps/web-b2b/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}